import { Skeleton } from '../ui/skeleton';

const SkeletonDashboard = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        heigth: '90%',
      }}>
      {/* <span style={{ fontSize: '30px', fontWeight: '500' }}>Dashboard Loading...</span>
                    <Waveform size={50} lineWeight={3.5} speed={1} color='black' /> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '50px',
          margin: '10px 20px 20px 20px',
        }}>
        <Skeleton className='w-[23%] h-[125px] rounded-[20px]' />
        <Skeleton className='w-[23%] h-[125px] rounded-[20px]' />
        <Skeleton className='w-[23%] h-[125px] rounded-[20px]' />
        <Skeleton className='w-[23%] h-[125px] rounded-[20px]' />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Skeleton className='w-[48%] h-[400px] mb-2.5 rounded-[20px]' />
          <Skeleton className='w-[48%] h-[400px] mb-2.5 rounded-[20px]' />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Skeleton className='w-[48%] h-[400px] rounded-[20px]' />
          <Skeleton className='w-[48%] h-[400px] rounded-[20px]' />
        </div>
      </div>
    </div>
  );
};

export default SkeletonDashboard;
